import { createApp, h } from 'vue'
import type { DefineComponent } from "vue";
import { createInertiaApp } from '@inertiajs/vue3'
import DefaultLayout from "@/Layout/Default.vue";
import VueSignaturePad from 'vue-signature-pad'
import I18n, {setLocale} from "@/Plugins/i18n";
import * as bootstrap from 'bootstrap'
import '../sass/app.scss'

/* @ts-ignore */
window.bootstrap = bootstrap;


createInertiaApp({
    id: 'my-app',
    resolve: name => {
        const pages = import.meta.glob<DefineComponent>('./Pages/**/*.vue', { eager: true })
        let page = pages[`./Pages/${name}.vue`]
        page.default.layout = page.default.layout || DefaultLayout
        return page
    },
    async setup({ el, App, props, plugin }) {
        const pageProps = props?.initialPage?.props;
        const locale = pageProps?.locale || 'en';
        await setLocale(locale)

        createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(I18n)
            .use(VueSignaturePad)
            .mount(el)
    }
})
